import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  companyCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'companyModel',
    function (runtimeConstant, $http, $q, $filter, webApiSettings, Company) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE USER'),
        };
      }

      function sortColumns() {
        return [
          { column: 'name', title: 'NAME', type: 'text', sortOrder: 'asc' },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = null;
        deferred.resolve(filters);
        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();
        var url = 'companies';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Company(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function save(company) {
        var deferred = $q.defer();
        var url = 'companies';

        company.idStatus = company.companyStatus.id;
        company.idContract = company.contract.id;
        company.contract = null;
        if (company.id === 0) {
          $http.post(webApiSettings.apiServiceBaseUri + url, company).then(
            function () {
              deferred.resolve(true);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        } else {
          $http.put(webApiSettings.apiServiceBaseUri + url, company).then(
            function () {
              deferred.resolve(true);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );
        }

        return deferred.promise;
      }

      function load(id) {
        var deferred = $q.defer();

        var promiseContracts = $http
          .get(webApiSettings.apiServiceBaseUri + 'contracts/')
          .then(
            function (data) {
              return data;
            },
            function () {
              return null;
            }
          );

        if (id) {
          var url = 'companies/' + id;
          var promiseCompany = $http.get(
            webApiSettings.apiServiceBaseUri + url
          );

          var urlLogo = 'companies/' + id + '/logoBase64';
          var promiseLogo = $http
            .get(webApiSettings.apiServiceBaseUri + urlLogo)
            .then(
              function (data) {
                return data;
              },
              function () {
                return null;
              }
            );

          //q.all faz chamar todas as promises, e depois que tiver o resultado entra no then
          $q.all([promiseCompany, promiseLogo, promiseContracts]).then(
            function (results) {
              var companyResolved = resolveReferences(results[0].data);
              var logo = results[1];
              var contractsResolved = resolveReferences(results[2].data);

              var company = new Company(companyResolved, contractsResolved);
              company.logoBase64 = logo ? logo.data : '';

              deferred.resolve(company);
            },
            function (err) {
              handleError(err.data, err.status);
              deferred.reject(err);
            }
          );
        } else {
          promiseContracts.then(function (contracts) {
            var contractsResolved = resolveReferences(contracts.data);
            var company = new Company(null, contractsResolved);

            deferred.resolve(company);
          });
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'companies/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http.post(webApiSettings.apiServiceBaseUri + url, ids).then(
          function () {
            deferred.resolve(true);
          },
          function (err) {
            if (err.data.ModelState) {
              if (err.data.ModelState.UserCompanies) {
                deferred.reject({
                  title: $filter('translate')('HAS ASSOCIATE USERS'),
                  text: err.data.ModelState.UserCompanies[0],
                });
              }

              if (err.data.ModelState.Groups) {
                deferred.reject({
                  title: $filter('translate')('COMPANY HAS GROUPS'),
                  text: err.data.ModelState.Groups[0],
                });
              }

              if (err.data.ModelState.Folder) {
                deferred.reject({
                  title: $filter('translate')('COMPANY HAS FOLDERS'),
                  text: err.data.ModelState.Folder[0],
                });
              }
            }

            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var companyCrudFactory = {};

          companyCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          companyCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );

          return companyCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
